export default "__VITE_ASSET__6eM8vqek__"